export default "__VITE_ASSET__DP2QJq3u__"